import { MediaType, Image, Pdf, Video } from 'generated/graphql';

export const isImage = (file: { mediaType: MediaType }): file is Image => file.mediaType === MediaType.Image;

export const isPdf = (file: { mediaType: MediaType }): file is Pdf => file.mediaType === MediaType.Pdf;

export const isVideo = (file: { mediaType: MediaType }): file is Video => file.mediaType === MediaType.Video;

export const getMediaTypeFromFileType = (fileType: string): MediaType => {
	if (fileType.match(/^video/)) return MediaType.Video;
	if (fileType.match(/^application\/pdf/)) return MediaType.Pdf;
	return MediaType.Image;
};

export const seasonYearFormat = (seasonYear: number): string => {
	if (!seasonYear) return null;
	return seasonYear < 10 ? '200' + seasonYear : '20' + seasonYear;
};
